import { BorderForm } from "@src/core/styles";
import type { ChangeEvent, FC, SyntheticEvent } from "react";
import { useState, useCallback, memo, useEffect } from "react";
import {
  DescriptionTextWrapper,
  DescriptionText,
  FormTitle,
  StyledLabel,
  StyledUploadedFile,
  UploadFileWrapper,
  FooterForm,
  TabGroup,
  Tab,
  StyledLinearProgress,
} from "./load-file.styles";
import { ReactComponent as Add } from "@src/core/icons/add.svg";
import { Box, Button, LinearProgress } from "@mui/material";
import { Button as CustomButton } from "@src/components/ui";
import { useMutation } from "@tanstack/react-query";
import { Workspace } from "@src/core/services";
import { enqueueSnackbar } from "notistack";
import type { LoadFileProps } from "./load-file.types";
import { useParams } from "react-router-dom";

export const LoadFile: FC<LoadFileProps> = memo(({ setFileId }) => {
  const [uploadedFile, setUploadedFile] = useState<File | undefined>(undefined);
  const [active, setActive] = useState<boolean>(true);
  const [progress, setProgress] = useState(0);
  const [tabValue, setTabValue] = useState<string>("swagger");
  const { workspaceId } = useParams();

  const { mutateAsync } = useMutation(Workspace.uploadFile, {
    onSuccess: (response) => {
      enqueueSnackbar("Файл загружен", {
        variant: "reportComplete",
        className: "success",
        preventDuplicate: true,
      });
      setFileId(response.data.id);
    },
    onError: (error: Error) => {
        enqueueSnackbar(error.response.data.message, {
            variant: "reportComplete",
            className: "success",
            preventDuplicate: true,
        });
      // console.log(error.response.data.message);
    },
  });

  const uploadFile = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) setUploadedFile(event.target.files[0]);
    setProgress(100);
  }, []);

  const changeTab = (e: SyntheticEvent<HTMLDivElement>) => {
    setActive(!active);
    setTabValue(e.currentTarget.getAttribute("value") as string);
  };

  const formData = new FormData();

  const sendFile = async () => {
    formData.append("type", tabValue);
    if (uploadedFile) {
      formData.append("file_api", uploadedFile);
    } else {
      return null;
    }

    try {
      await mutateAsync(formData);
    } catch (error) {}
  };

  useEffect(() => {
    setUploadedFile(undefined);
    setProgress(0);
    setActive(true);
    setTabValue("swagger");
  }, [workspaceId]);

  return (
    <BorderForm>
      <FormTitle>Автоматическое построение маршрутов</FormTitle>
      <div>
        <input
          id="load-file"
          hidden
          accept="application/JSON"
          type="file"
          onChange={(e) => uploadFile(e)}
        />
        <UploadFileWrapper>
          <StyledLabel htmlFor={`load-file`}>
            <Button
              component="span"
              variant="outlined"
              size="small"
              startIcon={<Add />}
            >
              Выберите файл
            </Button>
          </StyledLabel>
          <StyledUploadedFile>{uploadedFile?.name}</StyledUploadedFile>
        </UploadFileWrapper>
      </div>
      <DescriptionTextWrapper>
        <DescriptionText>
          Загрузите файл для автоматического построение маршрута.
        </DescriptionText>
        <DescriptionText>Поддерживаются форматы файлов: *.json</DescriptionText>
          <DescriptionText>Максимальный размер файла: 12 мегабайт</DescriptionText>
      </DescriptionTextWrapper>
      <FooterForm>
        <TabGroup>
          <Tab
            active={active.toString()}
            onClick={changeTab}
            value="swagger"
          >
            Swagger
          </Tab>
          <Tab
            active={(!active).toString()}
            onClick={changeTab}
            value="postman"
          >
            Postman
          </Tab>
        </TabGroup>
        <CustomButton
          text="Загрузить"
          variant="label"
          borderradius="XXXL"
          onClick={sendFile}
          disabled={!uploadedFile ? true : false}
        />
      </FooterForm>
      <StyledLinearProgress value={progress}>
        <Box sx={{ width: "100%" }}>
          <LinearProgress
            variant="determinate"
            value={progress}
          />
        </Box>
      </StyledLinearProgress>
    </BorderForm>
  );
});
